namespace Fable.Import

open Fable.Core
open React

module ReactVirtualizedSelect =

    type Option = 
        | Label of string
        | Value of obj
        | Disabled of bool

    type Props =
        | Async of bool
        | LoadOptions of (string -> Fable.Import.JS.Promise<obj>)  // obj = { options: [] }
        | OnChange of (string -> unit)
        | Options of obj []
        | Placeholder of string
        | Value of string

    [<Import("default", "react-virtualized-select")>]
    type VirtualizedSelect(props) =
        inherit Component<obj, obj>(props)
    


// WEBPACK FOOTER //
// src/import/Fable.Import.ReactVirtualizedSelect.fs